import { useTranslation } from "react-i18next";
import { Globe, Plus } from "lucide-react";
import { getVerificationPresentation } from "../../utils/socialVerification";

const SHOW_SOCIAL_VERIFICATION = false;

const PlatformIcon = ({ icon, name }) => {
    if (!icon) return <Globe className="h-5 w-5 text-slate-400" />;
    return (
        <img
            src={icon}
            alt={name}
            className="h-6 w-6 object-contain"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
    );
};

const SocialMediaSection = ({ handles = {}, links = {}, verificationByPlatform = {}, isEditing, onOpenModal, platforms = [] }) => {
    const { t } = useTranslation();

    return (
        <div>
            <p className="text-sm font-semibold text-slate-900">{t("ACCOUNT_SOCIAL_MEDIA")}</p>
            <div className="mt-4 space-y-3">
                {platforms.map((platform) => {
                    const handle = handles[platform.key] || "";
                    const link = links[platform.key] || "";
                    const hasData = Boolean(handle);
                    const verification = getVerificationPresentation(verificationByPlatform[platform.key] || "unverified");

                    return (
                        <div
                            key={platform.key}
                            className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3"
                        >
                            <PlatformIcon icon={platform.icon} name={platform.name} />
                            <div className="min-w-0 flex-1">
                                <div className="flex flex-wrap items-center gap-2">
                                    <span className={`text-sm ${hasData ? "text-slate-700" : "text-slate-400"}`}>
                                        {handle || t("ACCOUNT_SOCIAL_NOT_CONNECTED")}
                                    </span>
                                    {hasData && SHOW_SOCIAL_VERIFICATION ? (
                                        <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${verification.className}`}>
                                            {verification.label}
                                        </span>
                                    ) : null}
                                </div>
                                {hasData && SHOW_SOCIAL_VERIFICATION ? (
                                    <p className="mt-0.5 text-xs text-slate-500">{verification.helpText}</p>
                                ) : null}
                                {link && (
                                    <p className="mt-0.5 truncate text-xs text-slate-500">{link}</p>
                                )}
                            </div>
                            {isEditing && !hasData && (
                                <button
                                    type="button"
                                    onClick={() => onOpenModal(platform.key)}
                                    className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-100 focus:outline-none"
                                >
                                    <Plus className="h-4 w-4" />
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SocialMediaSection;
